import { useState } from "react";
import FAQProgramsHeader from "./FAQProgramsHeader";
import FAQs from "./FAQs";
import Programs from "./Programs";

function FAQPrograms(props) {
    const { programs } = props;

    const [status, setStatus] = useState("faq");

    return (
        <div id="faq-programs">
            {/* <div id="faq-p-floating-bg"></div> */}
            <FAQProgramsHeader status={status} setStatus={setStatus} />

            <div id="faq-programs-content">
                {
                    status === "faq" && <FAQs />
                }

                {
                    status === "programs" && <Programs programs={programs} />
                }
            </div>
        </div>
    );
}

export default FAQPrograms;